/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentTypeCandidate/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentTypeCandidate({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentTypeCandidate"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsGreen700alpha50 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.50'
        })
let dtColorsGreen700alpha40 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.40'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentTypeCandidate.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2uDzWe': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-2-Z2uDzWe': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-3-Z2uDzWe': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-Z2uDzWe': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-5-Z2uDzWe': dtColorsGreen700alpha50,'--bc-6-Z2uDzWe': dtColorsGreen700alpha40}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}